export const Fonts = {
    Roboto : 'Roboto-Regular',
    RobotoMedium : 'Roboto-Medium',
    SFProDisplayRegular: 'SFProDisplay-Regular',
    SFProDisplayMedium :'SFProDisplay-Medium',
    SFProDisplaySemibold : 'SFProDisplay-Semibold',
    SFProDisplayBold : 'SFProDisplay-Bold',
}